// src/components/MapComponent.js
import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const Mapcomponent = () => {
  const containerStyle = {
    width: "100%",
    height: "400px",
  };

  // Coordinates for the school location (Replace with actual coordinates)
  const center = {
    lat: 27.1767, // Latitude
    lng: 78.0081, // Longitude
  };

  return (
    <LoadScript googleMapsApiKey="@react-google-maps/api">
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={15}>
        {/* Marker for the school location */}
        <Marker position={center} />
      </GoogleMap>
    </LoadScript>
  );
};

export default Mapcomponent;
